import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LocationType } from 'app/models';
import { StoreService } from 'app/services';

@Component({
    selector: 'partner-mart-locations-store-details',
    templateUrl: './partner-mart-locations-store-details.component.html',
    styleUrls: ['./partner-mart-locations-store-details.component.scss',
        '../../../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsStoreDetailsComponent implements OnInit {
    @Input()
    public storeId: number = 0;

    @Input()
    public store: any = {};

    public locationType = LocationType.LocationTypeList;

    public loading: boolean = true;

    public storeData: any = {};

    //Google maps autocomplete
    public map!: google.maps.Map;
    public geocoder!: google.maps.Geocoder;
    public marker!: google.maps.Marker;
    public addresses: any[] = [];
    private geocodeTimer: number = 0;

    public showMerchantCreateStoreSideBar: boolean = false;

    constructor(private messageService: MessageService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        if (this.storeId > 0) {
            this.getStore();
        }
    }

    getStore() {
        this.loading = true;
        const dto = {
            StoreId: this.storeId
        };

        this.storeService.getStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeData = data;
                this.storeData.LoacationTypeName = this.locationType.find(f => f.value === data.LocationTypeId).name;
                this.callGeocodeMap();
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    private callGeocodeMap() {
        window.setTimeout(() => {
            this.geocoder = new google.maps.Geocoder();
            this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
                zoom: 15,
                center: { lat: 14.5995, lng: 120.9842 },
            });
            this.marker = new google.maps.Marker({
                map: this.map,
                anchorPoint: new google.maps.Point(0, -29),
            });

            this.geocoder.geocode({ address: this.storeData.Address }, (results, status) => {
                if (status === 'OK') {
                    if (results !== null) {
                        this.map.setCenter(results[0].geometry.location);
                        this.marker.setPosition(results[0].geometry.location);
                    }
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
        }, 1000);
    }

    public openMerchantCreateStoreSideBar() {
        this.showMerchantCreateStoreSideBar = true;
    }
    changedShowMerchantCreateStoreSideBarEmit(value: any) {
        this.showMerchantCreateStoreSideBar = value;
    }
}
